
import { checkI18n } from '@/plugins/i18n'
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props: {
    greetings: {
      type: String,
      required: true
    },
    img: {
      type: String,
      required: true
    },
    isLinear: {
      type: Boolean,
      default: true
    }
  },

  setup (props) {
    const greetingCheck = computed(() => props.greetings || checkI18n('defaultTitle'))

    const greetingStyle = computed(() => ({
      fontSize: greetingCheck.value.length > 16 ? '24px' : '32px'
    }))

    return {
      greetingCheck,
      greetingStyle
    }
  }
})
